import React, { useEffect, useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import {
  RecoilRoot,
  atom,
  selector,
  useRecoilState,
  useRecoilValue,
} from "recoil"
import {
  sizeState,
  userObjState,
  editModeState,
  pagesObjState,
  themeState,
  copiedMarksState,
} from "../recoil-atom"

import { ItemTypes } from "./Constants.js"
import { useDrag, useDrop, DragPreviewImage } from "react-dnd"

import {
  Flex,
  FlexColumn,
  Input,
  Submit,
  DivRound,
  ListPages,
  PageMarks,
  GroupMarks,
  Mark,
  MarkIcon,
  MarkAction,
} from "../styled-components-openmark"
import styled, { css } from "styled-components"

import { SaveCopy } from "@styled-icons/fluentui-system-filled"

import CopiedMarks from "./CopiedMarks"

import { getTextLength, cutTextLimit } from "../jace"

const ListMark = ({ pageId, groupId, markId, mark }) => {
  const [size, setSize] = useRecoilState(sizeState)
  const [theme, setTheme] = useRecoilState(themeState)
  const [editMode, setEditMode] = useRecoilState(editModeState)
  const [userObj, setUserObj] = useRecoilState(userObjState)
  const [pagesObj, setPagesObj] = useRecoilState(pagesObjState)
  const [copiedMarks, setCopiedMarks] = useRecoilState(copiedMarksState)

  const [showCopiedMarks, setShowCopiedMarks] = useState(false)

  return (
    <>
      <Mark>
        <a href={mark.url} target="_blank">
          {mark.thumbnail ? (
            <MarkIcon thumbnail={mark.thumbnail} />
          ) : (
            <MarkIcon bgColor={mark.bgColor} color={mark.color}>
              {mark.title}
            </MarkIcon>
          )}
        </a>
        <div>
          {getTextLength(mark.title) > 18 ? (
            <span>{cutTextLimit(mark.title, 15)}⋯</span>
          ) : (
            mark.title
          )}
        </div>
        {editMode ? (
          <MarkAction
            // className="copy"
            onClick={() => {
              if (copiedMarks.length < 6) {
                setCopiedMarks([mark, ...copiedMarks])
              } else {
                // alert("Copy Box is full!")
              }
              setShowCopiedMarks(true)
              setTimeout(() => {
                setShowCopiedMarks(false)
              }, 500)
            }}
          >
            <SaveCopy size="20" color={theme.b2} />
          </MarkAction>
        ) : null}
      </Mark>

      {showCopiedMarks && <CopiedMarks />}

      {/* <style jsx>{`
        .copy {
          position: absolute;
          top: -7px;
          left: -7px;
        }
      `}</style> */}
    </>
  )
}

export default ListMark
